import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { ExpandableTriggerButton } from "../expandable";

var CardExpandableTriggerButton = /*#__PURE__*/_styled(ExpandableTriggerButton, {
  target: "e1nkmuww0"
})(process.env.NODE_ENV === "production" ? {
  name: "b1gh8l",
  styles: "position:absolute;top:10px;right:10px;z-index:1;"
} : {
  name: "b1gh8l",
  styles: "position:absolute;top:10px;right:10px;z-index:1;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL3RhYmxlL2NhcmQtbGF5b3V0L0NhcmRFeHBhbmRhYmxlVHJpZ2dlckJ1dHRvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSW9DIiwiZmlsZSI6Ii4uLy4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL3RhYmxlL2NhcmQtbGF5b3V0L0NhcmRFeHBhbmRhYmxlVHJpZ2dlckJ1dHRvbi50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IEV4cGFuZGFibGVUcmlnZ2VyQnV0dG9uIH0gZnJvbSAnLi4vZXhwYW5kYWJsZSc7XG5cbmNvbnN0IENhcmRFeHBhbmRhYmxlVHJpZ2dlckJ1dHRvbiA9IHN0eWxlZChFeHBhbmRhYmxlVHJpZ2dlckJ1dHRvbikoe1xuICBwb3NpdGlvbjogJ2Fic29sdXRlJyxcbiAgdG9wOiAxMCxcbiAgcmlnaHQ6IDEwLFxuICB6SW5kZXg6IDFcbn0pO1xuXG5leHBvcnQgZGVmYXVsdCBDYXJkRXhwYW5kYWJsZVRyaWdnZXJCdXR0b247XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export default CardExpandableTriggerButton;